import { tw } from 'twind';
import { Icon } from '@global-ecom/nitro-uds/elements';

import { useTranslate } from 'hooks/useTranslations';
import { AnalyticsEvents, event } from 'utils/analytics';
import { scrollTo } from 'utils/scroll-to';

export const CompleteTheLookBadge = () => {
  const translate = useTranslate();

  return (
    <div className={tw('absolute right-3 md:right-5 top-3 xl:top-5 z-10')}>
      <a
        href="#complete-the-look-carousel"
        className={tw(
          'invisible', // will get removed by onBundles in useStyliticsWidget
          'group transition-all',
          'relative overflow-hidden rounded-full focus:rounded-full',
          'outline-none ring-puma-gold focus:bg-puma-gold hover:bg-puma-gold',
          'bg-puma-black text-puma-black-900',
          'leading-tight uppercase font-bold text-xs',
          'flex flex-col items-center justify-center text-center',
          'h-20 w-20 px-2',
          'w-20 md:w-16 lg:w-20 h-20 md:h-16 lg:h-20'
        )}
        id="complete-the-look"
        onClick={e => {
          e.preventDefault();

          event(AnalyticsEvents.PDP_INTERACTION, {
            domevent: 'Stylitics - Complete the Look',
            domlabel: '',
          });

          scrollTo('complete-the-look-carousel', -80);
        }}
      >
        <p className="transform -translate-y-1 text-[12px] lg:text-xs whitespace-normal">
          {translate('completeTheLook')}
        </p>
        <span
          aria-hidden
          className="transition-all absolute left-1/2 -bottom-2 lg:bottom-0 transform -translate-x-1/2 -translate-y-3 group-hover:-translate-y-2 group-focus:-translate-y-2"
        >
          <Icon name="chevron-down" size="lg" />
        </span>
      </a>
    </div>
  );
};
